import angular from 'angular';
import scenes from './scenes';
import insuranceSummaryOfCoverModal from './insuranceSummaryOfCoverModal';

export default angular
  .module('insuranceSummaryOfCover.scenes.insuranceSummaryOfCoverModal', [
    scenes,
  ])
  .component('insuranceSummaryOfCoverModal', insuranceSummaryOfCoverModal).name;
